/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Dd_List7_DescInputs */

const es_nav_dd_list7_desc = /** @type {(inputs: Nav_Dd_List7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovecha la nueva ley y gana dinero con tu barco.`)
};

const gl_nav_dd_list7_desc = /** @type {(inputs: Nav_Dd_List7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveita a nova lei e gaña diñeiro co teu barco.`)
};

const en_nav_dd_list7_desc = /** @type {(inputs: Nav_Dd_List7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the new law and earn from your boat.`)
};

/**
* | output |
* | --- |
* | "Use the new law and earn from your boat." |
*
* @param {Nav_Dd_List7_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_dd_list7_desc = /** @type {((inputs?: Nav_Dd_List7_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dd_List7_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_dd_list7_desc(inputs)
	if (locale === "en") return en_nav_dd_list7_desc(inputs)
	return es_nav_dd_list7_desc(inputs)
});